/* Office Walker 2A — hero video controls: play/pause + mute toggle.
   Autoplay starts muted (browser requirement); the Sound button unmutes on a
   real user gesture. Play icon <-> pause icon; label reflects current state.

   LOCALISATION, 2026-08-07. The four labels used to be string literals here.
   Shopify cannot translate a .js asset, so a German visitor got English button
   text the moment they touched the controls. They now come off the hero element
   as data-label-*, rendered from locale keys in sections/ow2-hero.liquid. Read
   per hero instance, not globally, so two heroes on one page cannot collide.

   A missing attribute leaves the existing label alone rather than writing
   English over it. */
(function () {
  'use strict';
  var PLAY = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M4 3l9 5-9 5z"/></svg>';
  var PAUSE = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><rect x="4" y="3" width="3.2" height="10"/><rect x="8.8" y="3" width="3.2" height="10"/></svg>';

  document.querySelectorAll('[data-ow2-hero]').forEach(function (hero) {
    var video = hero.querySelector('video');
    if (!video) return;
    var playBtn = hero.querySelector('[data-ow2-play]');
    var soundBtn = hero.querySelector('[data-ow2-sound]');

    var L = {
      play: hero.getAttribute('data-label-play') || '',
      pause: hero.getAttribute('data-label-pause') || '',
      soundOn: hero.getAttribute('data-label-sound-on') || '',
      soundOff: hero.getAttribute('data-label-sound-off') || ''
    };

    function syncPlay() {
      if (!playBtn) return;
      playBtn.innerHTML = video.paused ? PLAY : PAUSE;
      var label = video.paused ? L.play : L.pause;
      if (label) { playBtn.setAttribute('aria-label', label); }
    }
    function syncSound() {
      if (!soundBtn) return;
      var label = video.muted ? L.soundOff : L.soundOn;
      if (label) { soundBtn.textContent = label; }
      soundBtn.setAttribute('aria-pressed', String(!video.muted));
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) { video.play(); } else { video.pause(); }
      });
      video.addEventListener('play', syncPlay);
      video.addEventListener('pause', syncPlay);
    }
    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted) {
          video.volume = 1;
          if (video.paused) { video.play(); }
        }
        syncSound();
      });
    }
    syncPlay();
    syncSound();
  });
})();
